import { useState } from 'react'

interface ConfirmDialogProps {
  title?: string
  message: string
  confirmLabel?: string
  onConfirm: () => void
  onCancel: () => void
}

export function ConfirmDialog({
  title = 'Konfirmasi',
  message,
  confirmLabel = 'Hapus',
  onConfirm,
  onCancel,
}: ConfirmDialogProps) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div className="absolute inset-0 bg-black/70" onClick={onCancel} />
      <div className="relative z-10 bg-zinc-900 rounded-xl border border-zinc-800 w-full max-w-sm mx-4 p-6 shadow-2xl">
        <h3 className="text-white font-semibold text-sm mb-2">{title}</h3>
        <p className="text-zinc-400 text-sm leading-relaxed">{message}</p>
        <div className="flex justify-end gap-2 mt-6">
          <button
            type="button"
            onClick={onCancel}
            className="px-4 py-2 text-xs text-zinc-400 hover:text-white transition-colors rounded hover:bg-zinc-800"
          >
            Batal
          </button>
          <button
            type="button"
            onClick={onConfirm}
            className="px-4 py-2 text-xs bg-red-600 hover:bg-red-500 text-white font-semibold rounded transition-colors"
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  )
}

interface ConfirmState {
  title?: string
  message: string
  confirmLabel?: string
  resolve: (value: boolean) => void
}

export function useConfirm() {
  const [state, setState] = useState<ConfirmState | null>(null)

  const confirm = (message: string, options?: { title?: string; confirmLabel?: string }) =>
    new Promise<boolean>((resolve) => {
      setState({ message, ...options, resolve })
    })

  const handleConfirm = () => { state?.resolve(true); setState(null) }
  const handleCancel = () => { state?.resolve(false); setState(null) }

  const dialog = state ? (
    <ConfirmDialog
      title={state.title}
      message={state.message}
      confirmLabel={state.confirmLabel}
      onConfirm={handleConfirm}
      onCancel={handleCancel}
    />
  ) : null

  return { confirm, dialog }
}
